import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createBetOutbound } from '../../../../api/outbound/pokerOutbounds';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { getShortRenderedValueStr } from '../../../../utils/numberPrecisionUtils';
import { Button } from '../../pixiComponents/button';
/**
 * This is slightly hacky.
 * If it is a player's turn and we detect that they are in a big blind "option" scenario, where they can "check or bet",
 * it makes sense for the button label to read "Raise To" as this is how players tend to refer to this action
 * ("I raised from the big blind" rather than "I bet from the big blind").
 * However, the server does not understand this as a valid "raise" action, and instead sees it as a "bet" action since
 * the player does not need to commit more chips to stay in the hand. In other words, the server lacks some nuance around
 * "big blind option".
 * Therefore, in a "big blind option" scenario, internally this is still a "bet" button that sends a "bet" outbound, but
 * visually it looks just like the raise button.
 */
function hasCheckOrRaiseOption({ betTotalAmountToCall, myTotalBetAmount, myNumChipsThisPhase }) {
    return betTotalAmountToCall === myTotalBetAmount && myNumChipsThisPhase > 0;
}
function getActionLabel(betSliderAmount, isSliderAtMax, myTurnProperties) {
    if (!isSliderAtMax) {
        if (hasCheckOrRaiseOption(myTurnProperties)) {
            return 'RAISE TO';
        }
        return 'BET';
    }
    if (betSliderAmount >= myTurnProperties.myNumChips) {
        return 'ALL-IN';
    }
    return 'BET POT';
}
function getActionSubLabel(betSliderAmount, myTurnProperties) {
    if (hasCheckOrRaiseOption(myTurnProperties)) {
        return getShortRenderedValueStr(betSliderAmount + myTurnProperties.myNumChipsThisPhase);
    }
    return getShortRenderedValueStr(betSliderAmount);
}
export const PixiBetButton = ({ betSliderAmount, bounds, myTurnProperties }) => {
    const socketSend = useSocketSend();
    const onClickBet = useCallback(() => {
        socketSend(createBetOutbound(myTurnProperties.betSequenceNumber, betSliderAmount));
    }, [myTurnProperties, socketSend, betSliderAmount]);
    const isSliderAtMax = betSliderAmount >= myTurnProperties.betSliderMaxAmount;
    return (_jsx(Button, { pixiObjectData: { type: 'bet-button' }, onClick: onClickBet, labelProperties: {
            label: getActionLabel(betSliderAmount, isSliderAtMax, myTurnProperties),
            bitmapTextStyleType: 'button-label',
            labelPixiDataType: 'bet-button-label'
        }, subLabelProperties: {
            label: getActionSubLabel(betSliderAmount, myTurnProperties),
            bitmapTextStyleType: 'button-sub-label',
            labelPixiDataType: 'bet-button-sub-label'
        }, bounds: bounds, accentColor: 'green' }));
};
